export var ProductSelectionType;
(function (ProductSelectionType) {
    ProductSelectionType["Config"] = "Config";
})(ProductSelectionType || (ProductSelectionType = {}));
export const ChangeOrderScenarios = {
    postpaid: 'postpaid',
    priceLowerBeforeCapture: 'priceLowerBeforeCapture',
    priceEqualBeforeCapture: 'priceEqualBeforeCapture',
    priceHigherAuthorizedBeforeCapture: 'priceHigherAuthorizedBeforeCapture',
    priceHigherBeforeCapture: 'priceHigherBeforeCapture',
    priceLowerAfterCapture: 'priceLowerAfterCapture',
    priceEqualAfterCapture: 'priceEqualAfterCapture',
    priceHigherAfterCapture: 'priceHigherAfterCapture',
};
